export default {"src":"/frontend-static/_next/static/media/appStoreEs.b01daa1b.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};